export const getMillisecondsOnMinutesFormat = (milliseconds) => {
  const time = new Date(milliseconds);

  const pad = (value) => `0${value}`.slice(-2);

  return `${time.getUTCHours() > 0 ? `${time.getUTCHours()}:` : ''}${pad(
    time.getUTCMinutes()
  )}:${pad(time.getUTCSeconds())}`;
};
